import { SetStateAction, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AxiosResponse } from 'axios';

import {
  setDisplayCharts,
  updateClusters,
  updateMarkers,
} from '../redux/dashboardActions';

import {
  updateRealtyOffersSecondary,
  clearFiltersSecondary,
  updateInputIntervalsSecondaryGeneral,
} from './redux/offersSecondary.actions';

import {
  setMaxDate,
  setMaxUsefulArea,
  setMinDate,
  setMinMaxAreaLocalFilters,
  setMinMaxDateLocalFilters,
  setMinUsefulArea,
} from '../charts/redux/charts.actions';

import {
  handleInputsIntervals,
  handlePriceInputs,
  validateForm,
} from './redux/offersSecondary.controller';

import { getAvaliableFilters } from './infra';

import { SecondaryMarketInputs } from '../types';

import {
  Button,
  Input,
  IResponse,
  Select,
  SelectCalendar,
  MenuWrapper,
  Spinner,
  Checkbox,
} from '../../../component';

import './realtyOffers.scss';

type RealtyOffersSecondaryProps = {
  closeModalAction?: () => void;
};

const RealtyOffersSecondaryGeneral = ({
  closeModalAction,
}: RealtyOffersSecondaryProps) => {
  const dispatch = useDispatch();

  const { preference } = useSelector((state: any) => state.layoutState);
  const nls = require(`./nls/${preference.language.id}.json`);

  const { realtyOffersFiltersOptions, realtyOffersSecondaryGeneral } =
    useSelector((state: any) => state.offersSecondaryGeneralState);

  const { bedrooms, suites, garages, inputIntervals } =
    realtyOffersSecondaryGeneral;

  const { timeframe } = inputIntervals;

  const { moreFilters } = useSelector((state: any) => state.moreFiltersState);

  const { minMaxArea, minMaxDate } = useSelector(
    (state: any) => state.chartsState.localFilters
  );

  const { markers, clusters } = useSelector(
    (state: any) => state.dashboardState
  );

  const { elastic_city_id } = useSelector(
    (state: any) => state.mapSearch.selectedCity || {}
  );

  const { adTypes, realtyTypes } = realtyOffersFiltersOptions;

  const [validation, setValidation]: any = useState({});
  const [avaliableProgramFilters, setAvaliableProgramFilters] = useState({
    bedroom: true,
    suite: true,
    garage: true,
  });
  const [avaliableInputIntervals, setAvaliableInputIntervals] =
    useState(inputIntervals);
  const [avaliableFilterYears, setAvaliableFilterYears] = useState<
    string[] | []
  >([]);
  const [filtersInRegion, setFiltersInRegion] = useState<null>(null);
  const [adTypeTypeFilterIsActive, setAdTypeFilterIsActive] = useState(true);
  const [realtyTypeFilterIsActive, setRealtyTypeFilterIsActive] =
    useState(true);
  const [filtersErrorMessage, setFiltersErrorMessage] = useState<null | string>(
    null
  );
  const hasErrors =
    Object.values(validation).length > 0 &&
    Object.values(validation).every((elem) => !!elem);
  const inputPatterns: SecondaryMarketInputs = {
    timeframemin: {
      pattern: 'number',
      erro: validation,
      message:
        validation.timeframemin === 'biggerThanMax' ? nls.minBiggerThanMax : '',
    },
    timeframemax: {
      pattern: 'number',
      erro: validation,
      message:
        validation.timeframemax === 'smallerThanMin'
          ? nls.maxSmallerThanMin
          : '',
    },
    privateAreaIntervalmin: {
      pattern: 'number',
      erro: validation,
      message:
        validation.privateAreaIntervalmin === 'biggerThanMax'
          ? nls.minBiggerThanMax
          : '',
    },
    privateAreaIntervalmax: {
      pattern: 'number',
      erro: validation,
      message:
        validation.privateAreaIntervalmax === 'smallerThanMin'
          ? nls.maxSmallerThanMin
          : '',
    },
    pricePerSquareMtmin: {
      pattern: 'number',
      erro: validation,
      message:
        validation.pricePerSquareMtmin === 'biggerThanMax'
          ? nls.minBiggerThanMax
          : '',
    },
    pricePerSquareMtmax: {
      pattern: 'number',
      erro: validation,
      message:
        validation.pricePerSquareMtmax === 'smallerThanMin'
          ? nls.maxSmallerThanMin
          : '',
    },
    unitPricemin: {
      pattern: 'number',
      erro: validation,
      message:
        validation.unitPricemin === 'biggerThanMax' ? nls.minBiggerThanMax : '',
    },
    unitPricemax: {
      pattern: 'number',
      erro: validation,
      message:
        validation.unitPricemax === 'smallerThanMin'
          ? nls.maxSmallerThanMin
          : '',
    },
    realtyAgemin: {
      pattern: 'number',
      erro: validation,
      message:
        validation.realtyAgemin === 'biggerThanMax' ? nls.minBiggerThanMax : '',
    },
    realtyAgemax: {
      pattern: 'number',
      erro: validation,
      message:
        validation.realtyAgemax === 'smallerThanMin'
          ? nls.maxSmallerThanMin
          : '',
    },
  };

  const handleSingleSelect = (value: string, name: string) => {
    const payload = {
      name,
      value,
    };

    dispatch(updateRealtyOffersSecondary(payload));
  };

  const handleClickSelect = (e: any, arrayName: string) => {
    const payload = {
      name: arrayName,
      value: e.value,
    };
    dispatch(updateRealtyOffersSecondary(payload));
  };

  const handleClickMultiSelect = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    array: Array<any>,
    arrayName: string
  ) => {
    const newArray = array.map((el) =>
      el.name === e.currentTarget.name ? { ...el, selected: !el.selected } : el
    );
    const payload = {
      name: arrayName,
      value: newArray,
    };
    dispatch(updateRealtyOffersSecondary(payload));
  };
  const validateInputs = (
    event: any,
    v: { name: string; message: string },
    key: string
  ) => {
    const replaceCurrency = (el: string) => {
      if (el.includes(',')) return el.replace(',', '.');
      if (el.includes('R$')) {
        return parseInt(el.split('R$')[1].replaceAll('.', ''));
      } else {
        return parseInt(el);
      }
    };
    const values = avaliableInputIntervals[key];
    let formattedValues = values;
    if (typeof values.min !== 'number' && typeof values.max !== 'number') {
      formattedValues = {
        min: values.min.length > 0 ? replaceCurrency(values.min) : '',
        max: values.max.length > 0 ? replaceCurrency(values.max) : '',
      };
    }

    if (Number(formattedValues.min) > Number(formattedValues.max)) {
      setValidation({ ...validation, [event.name]: v.message });
    } else if (!formattedValues.min && !formattedValues.max) {
      setValidation({
        ...validation,
        [`${key}min`]: false,
        [`${key}max`]: false,
      });
    } else {
      setValidation({
        ...validation,
        [`${key}min`]: false,
        [`${key}max`]: false,
      });
    }
  };
  const handleInput = (e: any, v: IResponse, tuple: Array<any>) => {
    let newMinUsefulArea: string | number = 0;
    let newMaxUsefulArea: string | number = 0;
    if (v.name.includes('privateAreaIntervalmin')) {
      newMinUsefulArea = e.value.length > 0 ? e.value : 0;
      dispatch(
        setMinMaxAreaLocalFilters({ ...minMaxArea, min: newMinUsefulArea })
      );
    } else if (v.name.includes('privateAreaIntervalmax')) {
      newMaxUsefulArea = e.value.length > 0 ? e.value : 0;
      dispatch(
        setMinMaxAreaLocalFilters({ ...minMaxArea, max: newMaxUsefulArea })
      );
    }
    const typeNumber = !e.name.includes('privateAreaInterval') ? 'int' : '';
    if (e.name.toLowerCase().includes('price')) {
      dispatch(handlePriceInputs(e, v, tuple, 'secondary'));
    } else {
      dispatch(handleInputsIntervals(e, v, tuple, 'secondary', typeNumber));
    }
  };

  const dataValidacao = (e: any) => {
    const val = e.split('-');
    return Number(`${val[1]}${val[0]}`);
  };

  const handleInputCalendar = (e: any, v: any) => {
    const newMinDate = e.value.min.length > 0 ? e.value.min : 0;
    const newMaxDate = e.value.max.length > 0 ? e.value.max : 0;
    if (e.value.min && e.value.max) {
      if (dataValidacao(e.value.min) <= dataValidacao(e.value.max)) {
        setValidation({ ...validation, [e.name]: false });
      } else {
        setValidation({ ...validation, [e.name]: 'Final menor que inicial' });
      }
    } else {
      if (e.value.min === '' && e.value.max === '') {
        setValidation({ ...validation, [e.name]: false });
      } else {
        setValidation({ ...validation, [e.name]: 'Preencha os campos' });
      }
    }
    dispatch([
      setMinMaxDateLocalFilters({ max: newMaxDate, min: newMinDate }),
      updateInputIntervalsSecondaryGeneral(e),
    ]);
  };

  useEffect(() => {
    getAvaliableFiltersByCity(elastic_city_id);
  }, [elastic_city_id]);

  useEffect(() => {
    avaliableFiltersRules(filtersInRegion);
  }, [timeframe]);

  const clearAvaliableFiltersState = () => {
    setAvaliableInputIntervals(false);
    setFiltersErrorMessage(null);
    setRealtyTypeFilterIsActive(false);
    setFiltersInRegion(null);
    setAvaliableProgramFilters({
      bedroom: true,
      suite: true,
      garage: true,
    });
  };

  const updateRealtyProgramFilters = (
    filterName: string,
    filterValue: boolean
  ) => {
    const updatedFilters = { ...avaliableProgramFilters };

    if (filterName === 'bedroom') {
      updatedFilters.bedroom = filterValue;
    } else if (filterName === 'garage') {
      updatedFilters.garage = filterValue;
    } else if (filterName === 'suite') {
      updatedFilters.suite = filterValue;
    }

    setAvaliableProgramFilters(updatedFilters);
  };

  const avaliableFiltersRules = (
    filtersData: Record<string, boolean> | null
  ) => {
    let inputIntervalsList = inputIntervals;
    let realtyProgramFilters = avaliableProgramFilters;

    if (filtersData) {
      Object.entries(filtersData)?.map((filter) => {
        const filterName: string = filter[0];
        const filterValue: boolean = filter[1];

        if (filterName === 'adType') {
          setAdTypeFilterIsActive(filterValue);
        }

        if (filterName === 'realtyType') {
          setRealtyTypeFilterIsActive(filterValue);
        }

        if (!filterValue) {
          switch (filterName) {
            case 'advertisementPeriod': {
              delete inputIntervalsList['timeframe'];
              break;
            }
            case 'privateArea': {
              delete inputIntervalsList['privateAreaInterval'];
              break;
            }
            case 'squareMeterPrice': {
              delete inputIntervalsList['pricePerSquareMt'];
              break;
            }
            case 'price': {
              delete inputIntervalsList['unitPrice'];
              break;
            }
            case 'realtyAge': {
              delete inputIntervalsList['realtyAge'];
              break;
            }
            case 'bedroom':
            case 'garage':
            case 'suite':
              updateRealtyProgramFilters(filterName, filterValue);
              break;
            default: {
              break;
            }
          }
        }

        setAvaliableInputIntervals(inputIntervalsList);
        setAvaliableProgramFilters(realtyProgramFilters);
      });
    }
  };

  const getAvaliableFiltersByCity = (cityId: string) => {
    clearAvaliableFiltersState();

    Promise.resolve(getAvaliableFilters(cityId))
      .then((response: AxiosResponse) => {
        const { filters, availableYears } = response?.data;

        if (availableYears) {
          setAvaliableFilterYears(availableYears);
          sessionStorage.setItem(
            'availableYears',
            JSON.stringify(availableYears)
          );
        }
        if (filters) {
          avaliableFiltersRules(filters);
          setFiltersInRegion(filters);
          sessionStorage.setItem('filters', JSON.stringify(filters));
        }
      })
      .catch((error) => {
        console.error(error);
        setFiltersErrorMessage(`${nls.error.avaliableFiltersError}`);
      });
  };

  const handleSubmit = () => {
    const currentCityId = elastic_city_id;

    if (clusters.activeMap_ !== undefined) {
      markers.forEach((el: any) => {
        el.setMap(null);
      });
      clusters.clearMarkers();
      dispatch([updateMarkers([]), updateClusters([])]);
    }

    dispatch([
      validateForm(
        realtyOffersSecondaryGeneral,
        validation,
        'secondary',
        moreFilters,
        currentCityId
      ),
      setDisplayCharts(null),
      setMinUsefulArea(minMaxArea.min),
      setMaxUsefulArea(minMaxArea.max),
      setMinDate(minMaxDate.min),
      setMaxDate(minMaxDate.max),
      closeModalAction?.(),
    ]);
  };

  const handleClearFilters = () => {
    dispatch([
      setMinMaxAreaLocalFilters({ min: 0, max: 0 }),
      setMinMaxDateLocalFilters({ min: 0, max: 0 }),
      clearFiltersSecondary(),
    ]);
  };

  const dataAtual = new Date();

  return (
    <MenuWrapper
      title={nls.secondaryMarketMenuTitle}
      market="Secondary"
      submitButtonLabel={filtersErrorMessage ? nls.toSearch : nls.toApply}
      clearButtonLabel={nls.clearFilters}
      submitAction={handleSubmit}
      clearAction={handleClearFilters}
      isLoading={!avaliableInputIntervals}
      withoutCleanAction={filtersErrorMessage ? true : false}
      isDisabled={hasErrors}
    >
      <div className="realty-offers-primary-full-container">
        <div className="title-and-inputs-container">
          {avaliableInputIntervals ? (
            <>
              {adTypeTypeFilterIsActive && (
                <div className="input-section-container">
                  <div className="input-section-container__title">
                    <span data-cy={'ContainerTitleRealtyType'}>
                      {nls.adType}
                    </span>
                  </div>
                  <div className="checkbox-container">
                    {adTypes?.map((el: any) => (
                      <Checkbox
                        key={el.id}
                        cy={`AdTypeFilter${el.id}`}
                        action={() => handleSingleSelect(el.id, 'adType')}
                        checked={realtyOffersSecondaryGeneral?.adType === el.id}
                        name={el.id}
                        label={el.name}
                        type="checkbox"
                      />
                    ))}
                  </div>
                </div>
              )}
              {realtyTypeFilterIsActive && (
                <div className="periodo-lancamento">
                  <div
                    className="inputs-container-title"
                    style={{ paddingTop: 4 }}
                  >
                    <span
                      data-cy={`ContainerTitleRealtyType`}
                      className="title-span"
                    >
                      {nls.realtyType}
                    </span>
                    <span
                      data-cy={`ContainerTitleMandatoryRealtyType`}
                      className="optional-span"
                    >
                      {nls.mandatory}
                    </span>
                  </div>
                  <Select
                    label=""
                    cy="RealtyType"
                    options={realtyTypes}
                    action={(e: any) => handleClickSelect(e, 'realtyType')}
                    selected={realtyOffersSecondaryGeneral.realtyType || ''}
                    name="realtyType"
                  />
                </div>
              )}
              {Object.entries(avaliableInputIntervals)?.map(
                (input: any, index: number) => {
                  return (
                    <div
                      className="timeframe-container row-container"
                      key={`input-container-${index}`}
                    >
                      <div className="inputs-container-title">
                        <span
                          data-cy={`ContainerTitle${input[0]}`}
                          className="title-span"
                        >
                          {input[0] === 'timeframe'
                            ? nls.timeframeSecondary
                            : nls[input[0]]}
                        </span>
                      </div>
                      {input[0] === 'timeframe' ? (
                        <div className="calendario-ano">
                          <div className="row-container inputs-container">
                            <section className="calendar-left-selector">
                              <SelectCalendar
                                name={`${input[0]}`}
                                type="yearMonth"
                                placeholder={nls.initial}
                                action={(e: any, v: any) => {
                                  handleInputCalendar(
                                    {
                                      name: e.name,
                                      value: { ...input[1], min: e.value },
                                    },
                                    v
                                  );
                                }}
                                selected={input[1].min}
                                dataInicio={`00/${parseInt(
                                  avaliableFilterYears[0]
                                )}`}
                                dataFim={`${dataAtual.getMonth()}/${avaliableFilterYears.slice(
                                  -1
                                )}`}
                                withIcon
                                cy="min"
                                required={
                                  inputPatterns[
                                    `${input[0]}min` as keyof SecondaryMarketInputs
                                  ]
                                }
                              />
                            </section>
                            <section className="calendar-right-selector">
                              <SelectCalendar
                                name={`${input[0]}`}
                                type="yearMonth"
                                placeholder={nls.final}
                                action={(e: any, v: any) => {
                                  handleInputCalendar(
                                    {
                                      name: e.name,
                                      value: { ...input[1], max: e.value },
                                    },
                                    v
                                  );
                                }}
                                selected={input[1].max}
                                dataInicio={`00/${parseInt(
                                  avaliableFilterYears[0]
                                )}`}
                                dataFim={`${dataAtual.getMonth()}/${avaliableFilterYears.slice(
                                  -1
                                )}`}
                                cy="max"
                                withIcon
                                required={
                                  inputPatterns[
                                    `${input[0]}max` as keyof SecondaryMarketInputs
                                  ]
                                }
                              />
                            </section>
                          </div>
                          {validation?.[input[0]] ? (
                            <span
                              className="campo-obrigatorio-erro"
                              data-cy="MandatorySelectCalendaraFieldSpan"
                            >
                              {validation[input[0]]}
                            </span>
                          ) : null}
                        </div>
                      ) : (
                        <div className="row-container inputs-container">
                          <div>
                            <Input
                              cy={`${input[0]}Min`}
                              action={(e, v) => handleInput(e, v, input[1])}
                              actionBlur={(e, v) =>
                                validateInputs(
                                  e,
                                  { ...v, message: 'biggerThanMax' },
                                  input[0]
                                )
                              }
                              name={`${input[0]}min`}
                              placeholder={nls.initial}
                              value={input[1].min}
                              required={
                                inputPatterns[
                                  `${input[0]}min` as keyof SecondaryMarketInputs
                                ]
                              }
                              key={`${input[0]}Min`}
                            />
                          </div>
                          <div>
                            <Input
                              cy={`${input[0]}Max`}
                              action={(e, v) => handleInput(e, v, input[1])}
                              actionBlur={(e, v) =>
                                validateInputs(
                                  e,
                                  { ...v, message: 'smallerThanMin' },
                                  input[0]
                                )
                              }
                              name={`${input[0]}max`}
                              placeholder={nls.final}
                              value={input[1].max}
                              required={
                                inputPatterns[
                                  `${input[0]}max` as keyof SecondaryMarketInputs
                                ]
                              }
                              key={`${input[0]}Max`}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  );
                }
              )}
              <div className="buttons-container row-container">
                {avaliableProgramFilters?.bedroom && (
                  <>
                    <span
                      data-cy="ContainerTitleBedrooms"
                      className="title-span"
                    >
                      {nls.bedrooms}
                    </span>
                    <div className="multiselect-buttons-container row-container">
                      {bedrooms?.map((item: any) => (
                        <Button
                          className={`multi-select-button ${
                            item.selected ? 'selected' : ''
                          }`}
                          cy={`BedroomsMultiSelect[${item.name}]`}
                          name={item.name}
                          key={item.name}
                          onClick={(e) =>
                            handleClickMultiSelect(e, bedrooms, 'bedrooms')
                          }
                        >
                          {item.name}
                        </Button>
                      ))}
                    </div>
                  </>
                )}
              </div>
              <div className="buttons-container row-container">
                {avaliableProgramFilters?.suite && (
                  <>
                    <span data-cy="ContainerTitleSuites" className="title-span">
                      {nls.suites}
                    </span>
                    <div className="multiselect-buttons-container row-container">
                      {suites?.map((item: any) => (
                        <Button
                          className={`multi-select-button  ${
                            item.selected ? 'selected' : ''
                          }`}
                          cy={`SuitesMultiSelect[${item.name}]`}
                          name={item.name}
                          key={item.name}
                          onClick={(e) =>
                            handleClickMultiSelect(e, suites, 'suites')
                          }
                        >
                          {item.name}
                        </Button>
                      ))}
                    </div>
                  </>
                )}
              </div>
              <div className="buttons-container row-container">
                {avaliableProgramFilters?.garage && (
                  <>
                    <span
                      data-cy="ContainerTitleGarages"
                      className="title-span"
                    >
                      {nls.garages}
                    </span>
                    <div className="multiselect-buttons-container row-container">
                      {garages?.map((item: any) => (
                        <Button
                          className={`multi-select-button  ${
                            item.selected ? 'selected' : ''
                          }`}
                          cy={`GaragesMultiSelect[${item.name}]`}
                          name={item.name}
                          key={item.name}
                          onClick={(e) =>
                            handleClickMultiSelect(e, garages, 'garages')
                          }
                        >
                          {item.name}
                        </Button>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </>
          ) : (
            <>
              {filtersErrorMessage ? (
                <div className="filters-error">
                  <p className="filters-error__message">
                    {filtersErrorMessage}
                  </p>
                </div>
              ) : (
                <Spinner
                  withText
                  textValue={nls.loadingState.avaliableFilters}
                />
              )}
            </>
          )}
        </div>
      </div>
    </MenuWrapper>
  );
};

export default RealtyOffersSecondaryGeneral;
